import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})

export class TransitionsPropertiesService {
    public shouldHideContent = false;
    public shouldShowContent = false;
} 